<template>
  <div class="main">
    <clouded-glass class="space-choose">
      <div class="h-100 overflow-auto" slot="content">
        <div class="current-location" style="margin-right: 21px;">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的空间名称" size="mini"
                    @change="changeName"/>
        </div>
        <div class="current-location">
          <img alt="" src="../../../../assets/images/icon/location.png">
          当前空间:
          <span class="text-nowrap text-lightBlue">{{ checkSpace.title }}</span>
        </div>
        <space-tree-show @spaceChoose="spaceChoose" :checkShow=false class="space" ref="space"/>
      </div>
    </clouded-glass>
    <div class="contentRight">
      <el-row class="text-yellow" style="height: 20px;font-size: 0.8rem">* 单击图标并拖动放置位置(漏水图标不能移动位置),双击内景图图标编辑测点</el-row>
      <div class="availableDevice">
        <img :height="45.6" :key="item.id" :src="$ftpUrl + item.icon" :title="item.deviceName" :width="33.6"
          @touchstart="setPosition(item)"   @click="setPosition(item)" v-for="item in unBoundDeviceList">
      </div>
      <el-row style="width: 100%;overflow: auto;height: 75.8vh;text-align: center;margin-top: 2vh">
        <!--          内景图-->
        <edit-indoor-setting-device :space-id="checkSpace.id" @getUnboundDeviceList="getUnboundDeviceList"
                                    ref="editIndoorSetting"/>
      </el-row>

    </div>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import EditIndoorSettingDevice from "@/views/basic_operations/device_management/electronic_map/EditIndoorSettingDevice";

export default {
  name: "Index",
  components: {CloudedGlass, SpaceTreeShow, EditIndoorSettingDevice},
  data() {
    return {
      // 筛选的空间名称
      name: "",
      checkSpace: {},
      unBoundDeviceList: []
    }
  },
  methods: {
    spaceChoose(spaceInfo) {
      if (spaceInfo.type !== 1) {
        this.checkSpace = spaceInfo;
      } else {
        this.$message.error('此空间为逻辑空间,无法选择');
        let zTreeObj=this.$refs.space.ztreeObj;
        let node = zTreeObj.getNodeByParam('id',this.checkSpace.id);
        zTreeObj.selectNode(node)
      }
    },
    getUnboundDeviceList(data) {
      this.unBoundDeviceList = data
      console.log(this.unBoundDeviceList)
    },
    setPosition(item) {
      this.$refs.editIndoorSetting.stopDrag(null, item)
    },
    changeName(){
      this.$refs.space.changName(this.name);
    }
  }
}
</script>

<style scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

/*空间选择*/
.space-choose {
  float: left;
  height: 100%;
  width: 210px;
}

.current-location {
  margin-top: 30px;
  margin-left: 25px;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

.current-location img {
  margin-right: 5px;
}

.space-choose .space {
  margin: 20px 0 10px 30px;
  width: 160px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  font-size: 0.85rem;
  opacity: 1;
}

.contentRight {
  margin-left: 230px;
  width: calc(100vw - 485px);
}

.availableDevice {
  white-space: nowrap; /*不换行*/
  overflow-x: auto;
  margin-top: 10px;
}

.availableDevice img {
  margin: 10px 15px 10px 0;
  cursor: pointer;
}

@media (max-width: 1028px) {
  .main {
    height: auto;
  }

  .space-choose {
    height: auto;
    width: 300px;
    float: none;
    padding-bottom: 10px;
  }

  .contentRight {
    width: 100%;
    height: 100%;
    margin: 20px 0;
  }
}

</style>
